import { render, staticRenderFns } from "./CourseTableMore.vue?vue&type=template&id=1b89032a"
import script from "./CourseTableMore.vue?vue&type=script&lang=js"
export * from "./CourseTableMore.vue?vue&type=script&lang=js"
import style0 from "./CourseTableMore.vue?vue&type=style&index=0&id=1b89032a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports